{
  "blocks": [
    {
      "id": "proc-pelvic-mri",
      "kind": "procedure",
      "tags": ["testing", "her", "clinic-visit"],
      "title": "Pelvic MRI",
      "subtitle": "Advanced imaging for detailed evaluation of pelvic structures",
      "body": {
        "procedureName": "Pelvic MRI",
        "category": "diagnostic",
        "description": "Magnetic resonance imaging of the pelvis provides highly detailed cross-sectional images of the uterus, ovaries, and surrounding tissues. Often used to evaluate endometriosis, fibroids, adenomyosis, or structural anomalies that ultrasound cannot fully characterize.",
        "howItWorks": "You lie on a padded table that slides into a large, tube-shaped scanner. The MRI uses strong magnetic fields and radio waves, not radiation, to create detailed images of soft tissues. The scan captures multiple image slices of your pelvis from different angles. You'll hear rhythmic knocking sounds during the scan and will be given earplugs or headphones. In some cases, a contrast dye (gadolinium) is injected through an IV to highlight certain tissues. The images are interpreted by a radiologist and shared with your fertility doctor.",
        "duration": "30–60 minutes",
        "anesthesia": "none",
        "painAndComfort": [
          "The scan itself is painless, though staying still or being in an enclosed space may feel uncomfortable."
        ],
        "prepSummary": "Ask whether you need to fast if contrast is planned; remove metal before the scan.",
        "whatToExpect": [
          "You'll lie still on a table inside the scanner, which is enclosed but open at both ends",
          "The machine makes loud knocking and buzzing sounds (earplugs are provided)",
          "You may receive an IV contrast injection if your doctor ordered it",
          "No pain is involved, but staying still is important for clear images",
          "Results are typically available within 2–5 business days",
          "You can resume normal activities immediately after"
        ],
        "results": [
          {
            "label": "When you hear",
            "detail": "The radiology report is commonly available within 2-5 business days, depending on the imaging center."
          },
          {
            "label": "What you learn",
            "detail": "The report may describe fibroids, adenomyosis, endometriosis features, ovarian findings, or uterine anatomy."
          },
          {
            "label": "Follow-up",
            "detail": "Your fertility doctor should translate the radiology findings into treatment implications, because not every imaging finding changes the plan."
          }
        ],
        "prepInstructions": [
          "Remove all metal jewelry, piercings, and accessories before the scan",
          "Inform your clinic if you have any metal implants, a pacemaker, or claustrophobia",
          "You may be asked to fast for 4 hours if contrast dye is being used",
          "Wear comfortable clothing without metal zippers or clasps",
          "Arrive 15 minutes early to complete a metal-screening questionnaire"
        ],
        "risks": [
          "MRI is very safe: no radiation is involved",
          "Rare allergic reaction to contrast dye if used",
          "Mild discomfort from lying still in an enclosed space"
        ],
        "forWhom": "her",
        "frBody": {
          "procedureName": "IRM pelvienne",
          "description": "L'imagerie par résonance magnétique du pelvis fournit des images en coupe très détaillées de l'utérus, des ovaires et des tissus environnants. Souvent utilisée pour évaluer l'endométriose, les fibromes, l'adénomyose ou des anomalies structurelles que l'échographie ne permet pas de caractériser complètement.",
          "howItWorks": "Vous êtes allongée sur une table rembourrée qui glisse dans un grand appareil en forme de tube. L'IRM utilise des champs magnétiques puissants et des ondes radio, sans rayonnement ionisant, pour produire des images détaillées des tissus mous. L'examen capture plusieurs coupes du pelvis sous différents angles. Vous entendrez des bruits rythmés pendant l'examen ; des bouchons d'oreille ou un casque vous seront fournis. Dans certains cas, un produit de contraste (gadolinium) est injecté en intraveineuse pour mettre en évidence certains tissus. Les images sont interprétées par un radiologue puis transmises à votre médecin de la reproduction.",
          "duration": "30 à 60 minutes",
          "painAndComfort": [
            "L'examen est indolore, mais rester immobile ou être dans un espace fermé peut être inconfortable."
          ],
          "prepSummary": "Demandez si vous devez être à jeun si un produit de contraste est prévu ; retirez les objets métalliques avant l'examen.",
          "whatToExpect": [
            "Vous restez immobile sur la table à l'intérieur de l'appareil, ouvert aux deux extrémités",
            "L'appareil émet des bruits forts (bouchons d'oreille fournis)",
            "Vous pouvez recevoir une injection de contraste IV si elle est prescrite",
            "Examen indolore, mais il est important de rester immobile pour des images nettes",
            "Résultats généralement disponibles sous 2 à 5 jours ouvrés",
            "Reprise normale des activités immédiatement après"
          ],
          "prepInstructions": [
            "Retirez tous les bijoux, piercings et accessoires métalliques avant l'examen",
            "Signalez à votre centre tout implant métallique, pacemaker ou claustrophobie",
            "Un jeûne de 4 heures peut être demandé si un produit de contraste est utilisé",
            "Portez des vêtements confortables sans fermeture éclair ni boucle métallique",
            "Arrivez 15 minutes en avance pour remplir le questionnaire de sécurité IRM"
          ],
          "risks": [
            "L'IRM est très sûre : pas de rayonnement",
            "Rare réaction allergique au produit de contraste s'il est utilisé",
            "Léger inconfort lié à l'immobilité dans un espace fermé"
          ]
        }
      },
      "sources": [
        {
          "title": "ACR Appropriateness Criteria: Female Infertility",
          "authors": "Expert Panel on Women's Imaging",
          "journal": "Journal of the American College of Radiology",
          "year": 2020,
          "url": "https://acsearch.acr.org/docs/3093336/Narrative/",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
